export const ConfigurationsApi = {
  GetConfigurationsApi: `config/features`
};
